import {Component} from '@angular/core';
// noinspection ES6PreferShortImport
import {WidgetInputDirective} from '../../directives';

@Component({
  selector: 'pt-widget-contact-chooser',
  template: `
    <div
      class='widget-border'
      data-testid="widget-contact-chooser"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-contact-chooser-v0
        *ngSwitchCase='0'
        [lockAcquired]='lockAcquired'
        [initializationWidget]='initializationWidget'
        [status]='status'>
      </pt-widget-contact-chooser-v0>

      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetContactChooserComponent extends WidgetInputDirective {
}
